<template lang="pug">
v-textarea(
  label='Введите цитату',
  v-model='block.value',
  @input='$emit("update", block)'
)
</template>

<script>
import BaseBlock from './BaseBlock'
export default {
  extends: BaseBlock,
}
</script>
